// tslint:disable:max-line-length

import React from 'react';

export const UtilityExcel = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M16,0.5v15H3v-2H0v-11h3v-2H16z M15,1.5H4v1h6v11H4v1h11V1.5z M14,12.5v1h-3v-1H14z M14,10.5v1h-3v-1H14z M4,5.2H2.7l1.7,2.6l-1.9,2.7h1.3L5,8.6l1.2,1.9h1.3L5.7,7.8l1.7-2.6H6.1L5,6.9L4,5.2z M14,8.5v1h-3v-1H14z M14,6.5v1h-3v-1H14z M14,4.5v1h-3v-1H14z M14,2.5v1h-3v-1H14z" />
    </svg>
  );
};
